export default __webpack_public_path__ + "static/media/icon-arrow-down.bad4209e.svg";